import { setTokenHeader } from './setTokenHeader';

export const mutationRequestConfig = (axiosConfig) => {
    setTokenHeader(axiosConfig);

    return axiosConfig;
};
